import React from "react";
import Expenses from "@/pages/Expenses";
import { useAuth } from "@/contexts/AuthContext";

export default function Approvals() {
  const { user } = useAuth();
  const title = user?.role === "finance" ? "Awaiting payment" : "Awaiting your review";
  return <Expenses scope="queue" title={title} />;
}
